import api from "../services/api";

export const createObservacao = (payload) =>
  api.post("/observacao/create", payload);
